import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
const IMAGES = {
  mainBook: "https://cdn.magicpatterns.com/uploads/v1QsaVpyY9GH4JQ5gaVfgx/ChatGPT_Image_27_ago_2026,_17_18_39.webp",
  packCompleto: "https://cdn.magicpatterns.com/uploads/pYiYocj2orM7TxQmykg8r4/ChatGPT_Image_27_ago_2026,_17_16_32.webp",
  bonus1: "https://cdn.magicpatterns.com/uploads/iTZkkpLUE3e6LsQYEsvkdQ/ChatGPT_Image_27_ago_2026,_18_19_26.webp",
  bonus2: "https://cdn.magicpatterns.com/uploads/65MtA98jpsW7xj65LQHk5G/ChatGPT_Image_27_ago_2026,_17_29_24.webp",
  bonus3: "https://cdn.magicpatterns.com/uploads/d3cryZbVaxu2SKdXnovqPQ/ChatGPT_Image_27_ago_2026,_18_21_33.webp",
  bonus4: "https://cdn.magicpatterns.com/uploads/hLfmvemPTEnGcXMUEK3B1y/Diseno_sin_titulo.jpg",
  bonus5: "https://cdn.magicpatterns.com/uploads/nAKZyikiLP9FfPqFyYFrui/Diseno_sin_titulo_(1).jpg",
  sample1: "https://cdn.magicpatterns.com/uploads/1ULH7f1FmH675nFxVrneGL/capture_260827_190244.webp",
  sample2: "https://cdn.magicpatterns.com/uploads/dgmtKHaUo8xWzxK2bTkTL5/capture_260827_190235.webp",
  sample3: "https://cdn.magicpatterns.com/uploads/waAh3auNGD1fAwoapocMQj/capture_260827_190158.webp",
  sample4: "https://cdn.magicpatterns.com/uploads/4FKGaBZFVNJRdVKWwvMjoH/capture_260827_190150.webp",
  sample5: "https://cdn.magicpatterns.com/uploads/tTWrussu1pQDMr7PaKPGj9/capture_260827_190141.webp"
};
const GameDecoration = ({
  type,
  className,
  style
}: {
  type: string;
  className?: string;
  style?: React.CSSProperties;
}) => {
  let svgContent = null;
  switch (type) {
    case 'pickaxe':
      svgContent = <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" shapeRendering="crispEdges" className="w-full h-full drop-shadow-[2px_2px_0px_rgba(17,17,17,1)]" data-id="element-0" data-mp="38li7lebna3n2">
          <path d="M14 2v4h-1V4h-2V3H7V2h7z" fill="#55FFFF" data-id="element-1" data-mp="nvstx4mognvy" />
          <path d="M13 3v2h-1V4h-1V3h2z" fill="#FFFFFF" data-id="element-2" data-mp="nvasltl5rjh6" />
          <path d="M14 1h1v6h-1v1h-1v1h-1V8h1V6h1V2h-4v1H8v1H7v1H6V4h1V3h2V2h3V1h2z" fill="#111" data-id="element-3" data-mp="stuczpk3sn7f" />
          <path d="M11 5h2v2h-2V5zm-2 2h2v2H9V7zM7 9h2v2H7V9zM5 11h2v2H5v-2zM3 13h2v2H3v-2z" fill="#8B6346" data-id="element-4" data-mp="35ox2qy1z4t4" />
          <path d="M10 6h1v1h-1V6zm-2 2h1v1H8V8zm-2 2h1v1H6v-1zm-2 2h1v1H4v-1zm-2 2h1v1H2v-1z" fill="#5C4033" data-id="element-5" data-mp="3ubrgyizwqe3g" />
          <path d="M12 5h1v2h-1V5zm-2 2h1v2h-1V7zM8 9h1v2H8V9zM6 11h1v2H6v-2zM4 13h1v2H4v-2z" fill="#111" data-id="element-6" data-mp="d3cwhu6lt0hm" />
          <path d="M6 3h1v1H6V3zM12 9h1v1h-1V9z" fill="#111" data-id="element-7" data-mp="8648hcyry28g" />
        </svg>;
      break;
    case 'diamond':
      svgContent = <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" shapeRendering="crispEdges" className="w-full h-full drop-shadow-[2px_2px_0px_rgba(17,17,17,1)]" data-id="element-8" data-mp="3bmbevr8kqdkx">
          <path d="M7 1h2v1h2v1h1v2h1v6h-1v2h-1v1h-2v1H7v-1H5v-1H4v-2H3V5h1V3h1V2h2V1z" fill="#111" data-id="element-9" data-mp="3qdai0mqn49x4" />
          <path d="M7 2h2v1h2v1h1v2h1v5h-1v2h-1v1h-2v1H7v-1H5v-1H4v-2H3V6h1V4h1V3h2V2z" fill="#55FFFF" data-id="element-10" data-mp="3lieg8uvlq86t" />
          <path d="M6 3h3v1h1v1h1v2h-1V5H9V4H6V3z" fill="#FFFFFF" data-id="element-11" data-mp="2xsk2mb3gkfli" />
          <path d="M11 7v4h-1v2h-2v1H7v-1h2v-1h1V7h1z" fill="#00AAAA" data-id="element-12" data-mp="2sv0mf5n79sqx" />
        </svg>;
      break;
    case 'emerald':
      svgContent = <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" shapeRendering="crispEdges" className="w-full h-full drop-shadow-[2px_2px_0px_rgba(17,17,17,1)]" data-id="element-13" data-mp="1d4hod823dg7z">
          <path d="M6 1h4v2h2v2h1v6h-1v2h-2v2H6v-2H4v-2H3V5h1V3h2V1z" fill="#111" data-id="element-14" data-mp="ydikgac7bfuq" />
          <path d="M6 2h4v2h2v2h1v4h-1v2h-2v2H6v-2H4v-2H3V6h1V4h2V2z" fill="#55FF55" data-id="element-15" data-mp="13ey3xxyqdeb0" />
          <path d="M6 3h3v1h1v2h-1V4H6V3z" fill="#FFFFFF" data-id="element-16" data-mp="1r5kb7n0wuujy" />
          <path d="M10 11v2H6v-1h4v-1z" fill="#00AA00" data-id="element-17" data-mp="1w33p2ltp55bd" />
        </svg>;
      break;
    case 'torch':
      svgContent = <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" shapeRendering="crispEdges" className="w-full h-full drop-shadow-[2px_2px_0px_rgba(17,17,17,1)]" data-id="element-18" data-mp="1i2j8zxf61nlk">
          <path d="M7 4h2v10H7V4z" fill="#111" data-id="element-19" data-mp="6nw3ptdfo9bg" />
          <path d="M7 6h2v8H7V6z" fill="#8B6346" data-id="element-20" data-mp="6n4agp7b6noc" />
          <path d="M7 4h2v2H7V4z" fill="#FFAA00" data-id="element-21" data-mp="aqitzpughm6j" />
          <path d="M7 3h2v1H7V3z" fill="#FFFF55" data-id="element-22" data-mp="arbysl9uu1m1" />
          <path d="M7 2h2v1H7V2z" fill="#FFFFFF" data-id="element-23" data-mp="qxf7vqfa53ia" />
        </svg>;
      break;
    case 'grass-block':
      svgContent = <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" shapeRendering="crispEdges" className="w-full h-full drop-shadow-[2px_2px_0px_rgba(17,17,17,1)]" data-id="element-24" data-mp="m4uh6xro76iz">
          <path d="M1 1h14v14H1V1z" fill="#111" data-id="element-25" data-mp="c9an8gwo2hwv" />
          <path d="M2 5h12v9H2V5z" fill="#8B6346" data-id="element-26" data-mp="c6eo4p931n6u" />
          <path d="M2 2h12v3H2V2z" fill="#55A83C" data-id="element-27" data-mp="19uyiuzlasw7c" />
          <path d="M2 2h12v1H2V2z" fill="#75C765" data-id="element-28" data-mp="19tnfh0vrlqgr" />
          <path d="M2 5h1v1h2V5h2v2h2V5h2v1h2V5h1v1h-1v1h-1V6h-2v1H8V6H6v1H4V6H3v1H2V5z" fill="#55A83C" data-id="element-29" data-mp="14xyequ80e3iv" />
        </svg>;
      break;
    case 'chest':
      svgContent = <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" shapeRendering="crispEdges" className="w-full h-full drop-shadow-[2px_2px_0px_rgba(17,17,17,1)]" data-id="element-30" data-mp="vwruqb65iakv">
          <path d="M1 3h14v10H1V3z" fill="#111" data-id="element-31" data-mp="3gmh8ekv4bqbz" />
          <path d="M2 4h12v8H2V4z" fill="#A67B5B" data-id="element-32" data-mp="3glob0ai1ud6i" />
          <path d="M2 4h12v1H2V4zm0 3h12v1H2V7zm0 4h12v1H2v-1zM2 4h1v8H2V4zm11 0h1v8h-1V4z" fill="#3A2418" data-id="element-33" data-mp="1w4ezsdi9wtib" />
          <path d="M7 6h2v3H7V6z" fill="#111" data-id="element-34" data-mp="205qsirwg1uuq" />
          <path d="M7 6h2v2H7V6z" fill="#CCCCCC" data-id="element-35" data-mp="206jrh6p5vg2b" />
        </svg>;
      break;
    case 'pig':
      svgContent = <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" shapeRendering="crispEdges" className="w-full h-full drop-shadow-[2px_2px_0px_rgba(17,17,17,1)]" data-id="element-36" data-mp="2530kofb7wkm9">
          <path d="M3 4h10v8H3V4z" fill="#111" data-id="element-37" data-mp="2eueqt5xociod" />
          <path d="M4 5h8v6H4V5z" fill="#FFAAFF" data-id="element-38" data-mp="2jtrc3m8wdhou" />
          <path d="M6 8h4v2H6V8z" fill="#FF55FF" data-id="element-39" data-mp="2jsg8bmfgc9xq" />
          <path d="M5 7h1v1H5V7zm4 0h1v1H9V7z" fill="#111" data-id="element-40" data-mp="2nv323svoo4xk" />
          <path d="M4 7h1v1H4V7zm4 0h1v1H8V7z" fill="#FFFFFF" data-id="element-41" data-mp="2nti7k39dclzp" />
        </svg>;
      break;
    case 'gold':
      svgContent = <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" shapeRendering="crispEdges" className="w-full h-full drop-shadow-[2px_2px_0px_rgba(17,17,17,1)]" data-id="element-42" data-mp="thtrtyvbcfe9">
          <path d="M5 3h6v2h2v6h-2v2H5v-2H3V5h2V3z" fill="#111" data-id="element-43" data-mp="yihn4wqkriea" />
          <path d="M5 4h6v2h2v4h-2v2H5v-2H3V6h2V4z" fill="#FFAA00" data-id="element-44" data-mp="21s3xr4y8osn5" />
          <path d="M5 5h4v1h1v2h-1V6H5V5z" fill="#FFFF55" data-id="element-45" data-mp="1wt96rfq4bxry" />
          <path d="M9 9v2H5V9h4z" fill="#AA5500" data-id="element-46" data-mp="1wuu0520p5ao8" />
        </svg>;
      break;
    case 'trophy':
      svgContent = <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" shapeRendering="crispEdges" className="w-full h-full drop-shadow-[2px_2px_0px_rgba(17,17,17,1)]" data-id="element-47" data-mp="25tfiox664pp0">
          <path d="M4 2h8v5H4V2zm-2 2h2v3H2V4zm10 0h2v3h-2V4zm-7 5h2v4H5v-4zm-1 4h6v2H4v-2z" fill="#111" data-id="element-48" data-mp="2ko3lg3k6pa0x" />
          <path d="M5 3h6v3H5V3zm-2 2h1v1H3V5zm10 0h1v1h-1V5zm-6 4h2v3H7V9zm-2 4h6v1H5v-1z" fill="#FFAA00" data-id="element-49" data-mp="2tiqiocfp2g23" />
          <path d="M5 3h2v1H5V3zm-2 2h1v1H3V5z" fill="#FFFF55" data-id="element-50" data-mp="2phet26wtlutw" />
        </svg>;
      break;
    default:
      return null;
  }
  return <div className={`absolute pointer-events-none z-[1] ${className}`} style={style} data-id="element-51" data-mp="33hph726qwvbd">
      {svgContent}
    </div>;
};
const CountdownTimer = () => {
  const [timeLeft, setTimeLeft] = React.useState(30 * 60);
  React.useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => prev > 0 ? prev - 1 : 30 * 60);
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const minutes = Math.floor(timeLeft / 60).toString().padStart(2, '0');
  const seconds = (timeLeft % 60).toString().padStart(2, '0');
  const today = new Date();
  const days = ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'];
  const dayName = days[today.getDay()];
  const day = today.getDate();
  const month = today.getMonth() + 1;
  return <div className="bg-[#111] pixel-border p-2 mt-3 w-full max-w-[350px] flex flex-col items-center justify-center relative overflow-hidden" data-id="element-52" data-mp="2pg0j2pdtme6q">
      <p className="font-body font-bold text-yellow-pixel text-[12px] uppercase text-center mb-1 relative z-10" data-id="element-53" data-mp="2uby1d18n9um5">
        ⚠️ Oferta válida solo hoy {dayName} {day}/{month}
      </p>
      <div className="flex items-center gap-2 font-display text-2xl text-white text-outline-sm relative z-10" data-id="element-54" data-mp="2kfcq3y617n9v">
        <div className="bg-[#2D3748] px-2 py-0.5 pixel-border min-w-[50px] text-center" data-id="element-55" data-mp="30tavzv1ufg2i">{minutes}</div>
        <span className="text-yellow-pixel animate-pulse" data-id="element-56" data-mp="2vu7om3ye4xrd">:</span>
        <div className="bg-[#2D3748] px-2 py-0.5 pixel-border min-w-[50px] text-center" data-id="element-57" data-mp="2qvwf5uc0cp9o">{seconds}</div>
      </div>
    </div>;
};
const CTAButton = ({
  text = "QUIERO ACCEDER AHORA 🎮",
  className = "",
  showTimer = true,
  showFeatures = false
}) => <div className={`flex flex-col items-center w-full ${className}`} data-id="element-58" data-mp="2d5t0bofgjxu9">
    <a href="https://www.aprendejugando.shop/cart/43083545313355:1" className="btn-pixel w-full py-4 md:py-5 px-4 text-2xl md:text-3xl flex items-center justify-center text-center leading-tight shadow-[0_6px_0_#111] active:shadow-[0_0px_0_#111] active:translate-y-[6px] no-underline" data-id="element-59" data-mp="2d4hvrme6um23">
      {text}
    </a>
    {showTimer && <CountdownTimer data-id="element-60" data-mp="1yad2d8brbhsl" />}
    {showFeatures && <div className="flex flex-wrap justify-center gap-x-2 gap-y-1 mt-3 text-[12px] font-body font-bold text-[#111]" data-id="element-61" data-mp="1u7zvggl9xdu8">
        <span data-id="element-62" data-mp="9ocw6up8ji7z">⚡ Acceso inmediato</span>
        <span data-id="element-63" data-mp="dqho9p01c6si">·</span>
        <span data-id="element-64" data-mp="dpyewwogaqq3">📄 PDF</span>
        <span data-id="element-65" data-mp="dp6ixkqxyqza">·</span>
        <span data-id="element-66" data-mp="dooi0atc3ol1">🖨️ Imprimible</span>
        <span data-id="element-67" data-mp="ipu9y6f677ti">·</span>
        <span data-id="element-68" data-mp="ipb3pmyvu7vb">🔒 Pago seguro</span>
      </div>}
  </div>;
const AutoScrollCarousel = () => {
  const scrollRef = React.useRef<HTMLDivElement>(null);
  const [isHovered, setIsHovered] = React.useState(false);
  React.useEffect(() => {
    const el = scrollRef.current;
    if (!el) return;
    let animationId: number;
    const scroll = () => {
      if (!isHovered) {
        el.scrollLeft += 1;
        if (el.scrollLeft >= el.scrollWidth / 2) {
          el.scrollLeft = 0;
        }
      }
      animationId = requestAnimationFrame(scroll);
    };
    animationId = requestAnimationFrame(scroll);
    return () => cancelAnimationFrame(animationId);
  }, [isHovered]);
  const samples = [IMAGES.sample1, IMAGES.sample2, IMAGES.sample3, IMAGES.sample4, IMAGES.sample5];
  return <div className="w-full relative py-8 overflow-hidden bg-minecraft-landscape bg-cover bg-center border-y-4 border-[#111]" data-id="element-69" data-mp="2f7wtjdrigeol">
      <div className="absolute inset-0 bg-[#1A365D]/85" data-id="element-70" data-mp="2k4n7nvjr907d"></div>
      <motion.h2 initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.5
    }} className="font-display text-[26px] md:text-[32px] text-white text-outline text-center mb-8 uppercase relative z-10" data-id="element-71" data-mp="2p4rr9ufymb1t">
        UN VISTAZO POR DENTRO 👀
      </motion.h2>
      <div ref={scrollRef} className="flex gap-6 overflow-x-auto hide-scrollbar px-4 pb-4 snap-x relative z-10" onMouseEnter={() => setIsHovered(true)} onMouseLeave={() => setIsHovered(false)} onTouchStart={() => setIsHovered(true)} onTouchEnd={() => setIsHovered(false)} data-id="element-72" data-mp="21gi9r4ps49gh">
        {[...samples, ...samples, ...samples].map((src, i) => <div key={i} className="w-[260px] md:w-[320px] flex-shrink-0 bg-white pixel-border hard-shadow p-2 snap-center cursor-grab active:cursor-grabbing hover:-translate-y-2 transition-transform duration-300" data-id="element-73" data-mp="1io7dvutjlbrv" data-mpi={i}>
            <img src={src} alt={`Muestra ${i}`} className="w-full h-auto object-cover border-2 border-[#111]" data-id="element-74" data-mp="3ryf3bg5f85np" />
          </div>)}
      </div>
    </div>;
};
const SalesPopup = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [currentBuyer, setCurrentBuyer] = useState({
    name: '',
    location: '',
    time: ''
  });
  const names = ['María', 'Laura', 'Florencia', 'Sofía', 'Camila', 'Valeria', 'Romina', 'Luciana', 'Paula', 'Daniela', 'Carolina', 'Mariana', 'Julieta', 'Agustina'];
  const locations = ['Palermo', 'Belgrano', 'Caballito', 'Recoleta', 'Córdoba', 'Rosario', 'Mendoza', 'Mar del Plata', 'La Plata', 'Almagro', 'Vicente López', 'San Isidro', 'Quilmes', 'Neuquén', 'Tucumán'];
  const times = ['hace 2 minutos', 'hace 5 minutos', 'hace 12 minutos', 'hace 1 hora', 'hace 3 minutos', 'hace 8 minutos', 'hace 15 minutos'];
  useEffect(() => {
    // Initial delay before first popup
    const initialTimer = setTimeout(() => {
      showRandomBuyer();
    }, 5000);
    return () => clearTimeout(initialTimer);
  }, []);
  const showRandomBuyer = () => {
    const randomName = names[Math.floor(Math.random() * names.length)];
    const randomLocation = locations[Math.floor(Math.random() * locations.length)];
    const randomTime = times[Math.floor(Math.random() * times.length)];
    setCurrentBuyer({
      name: randomName,
      location: randomLocation,
      time: randomTime
    });
    setIsVisible(true);

    // Hide after 5 seconds
    setTimeout(() => {
      setIsVisible(false);

      // Schedule next popup between 10 and 20 seconds later
      const nextDelay = Math.floor(Math.random() * 10000) + 10000;
      setTimeout(showRandomBuyer, nextDelay);
    }, 5000);
  };
  return <AnimatePresence data-id="element-75" data-mp="3hap76uh95h6n">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      x: -20,
      scale: 0.9
    }} animate={{
      opacity: 1,
      y: 0,
      x: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.9
    }} transition={{
      type: "spring",
      stiffness: 400,
      damping: 25
    }} className="fixed bottom-4 left-4 z-50 bg-white pixel-border hard-shadow-sm p-3 flex items-center gap-3 max-w-[300px]" data-id="element-76" data-mp="3m3s153pxysnd">
          <div className="bg-grass-green w-10 h-10 flex-shrink-0 flex items-center justify-center pixel-border animate-gift-pop" data-id="element-77" data-mp="1fezua87c4igf">
            <span className="text-xl" data-id="element-78" data-mp="rq730p1nqys5">🎁</span>
          </div>
          <div className="flex flex-col" data-id="element-79" data-mp="mrdqozy3xdtk">
            <p className="font-body font-bold text-[13px] text-[#171717] leading-tight" data-id="element-80" data-mp="msf0z27atwa8">
              <span className="text-grass-green font-black" data-id="element-81" data-mp="11pfvtekse7cx">{currentBuyer.name}</span> de {currentBuyer.location} acaba de comprar el pack.
            </p>
            <p className="font-body font-bold text-[11px] text-gray-500 mt-0.5" data-id="element-82" data-mp="2d2icsaqssyxm">
              {currentBuyer.time}
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
};
export function App() {
  const faqs = [{
    q: "¿Qué recibo exactamente?",
    a: "Recibís un archivo digital (PDF) con más de 100 actividades de matemáticas, además de los 5 bonos exclusivos detallados en la página."
  }, {
    q: "¿Es un producto físico?",
    a: "No, es un producto 100% digital. Lo recibís en tu correo electrónico listo para descargar e imprimir las veces que quieras."
  }, {
    q: "¿Para qué edades sirve?",
    a: "El material está diseñado para niños que cursan entre 1.º y 5.º grado de primaria (aprox. 6 a 11 años), con niveles de dificultad progresivos."
  }, {
    q: "¿Puedo imprimir las actividades?",
    a: "¡Sí! Está diseñado específicamente para ser impreso. Podés imprimir todo el libro o solo las hojas que necesites en el momento."
  }, {
    q: "¿Puedo utilizarlo más de una vez?",
    a: "Al ser un archivo digital, podés imprimir las actividades todas las veces que necesites para tu hijo o tus alumnos."
  }, {
    q: "¿Sirve para docentes?",
    a: "Absolutamente. Muchos docentes utilizan este material en el aula como una forma divertida de repasar conceptos o como actividades de extensión."
  }, {
    q: "¿Necesito tener Minecraft?",
    a: "No, no es necesario tener el juego ni saber jugarlo. Las actividades usan la estética y temática visual para hacerlas más atractivas, pero se resuelven en papel."
  }, {
    q: "¿Cómo recibo el material?",
    a: "Inmediatamente después de confirmar el pago, recibirás un correo electrónico con los enlaces para descargar todo el material."
  }];
  return <div className="min-h-screen bg-[#111] flex justify-center font-body" data-id="element-83" data-mp="2c6btdxsdcl45">
      <SalesPopup data-id="element-84" data-mp="27fn1ihcs1m4h" />
      {/* Main Container - Narrow centered sales page */}
      <div className="w-full max-w-[800px] bg-sky-blue relative shadow-[0_0_30px_rgba(0,0,0,0.8)] overflow-hidden" data-id="element-85" data-mp="27din35h954py">
        
        {/* 1. HERO */}
        <section className="w-full bg-minecraft-landscape relative pb-8 overflow-hidden" style={{
        paddingBottom: "0px"
      }} data-id="element-86" data-mp="2zx7rfcnf4cju">
          {/* Decorative Elements */}
          <GameDecoration type="pickaxe" className="w-[70px] md:w-[90px] -left-[20px] top-[38%] -rotate-[20deg]" data-id="element-87" data-mp="t7xc8m4vjxom" />
          <GameDecoration type="diamond" className="w-[40px] md:w-[50px] right-[15px] top-[55%] animate-game-float" data-id="element-88" data-mp="y7jr100cplzj" />
          <GameDecoration type="grass-block" className="w-[40px] md:w-[60px] right-[10%] bottom-[10%]" data-id="element-89" data-mp="jivvuuuf3ea4" />

          {/* Top Strip */}
          <div className="bg-dark-brown text-white font-body font-bold text-[11px] md:text-sm h-[38px] px-4 flex justify-between items-center border-b-4 border-[#111] relative z-10" data-id="element-90" data-mp="ofe25z5ebkok">
            <span data-id="element-91" data-mp="fhai77a26vyv">🎮 MATEMÁTICAS EN MODO JUEGO</span>
            <span className="text-[#FFC928]" data-id="element-92" data-mp="jhzk697trgg">OFERTA ESPECIAL</span>
          </div>

          <div className="px-4 pt-5 pb-2 text-center flex flex-col items-center relative z-10" data-id="element-93" data-mp="lmf5lgh8ewk">
            {/* Small Badge */}
            <motion.div initial={{
            opacity: 0,
            y: -20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.5
          }} className="inline-flex items-center justify-center bg-yellow-pixel text-[#111] font-body font-black text-[11px] md:text-sm px-3 h-[32px] pixel-border hard-shadow-sm mb-4 uppercase leading-none" data-id="element-94" data-mp="1uwrguk806h99">
              🎮 +100 ACTIVIDADES · 1.º A 5.º DE PRIMARIA
            </motion.div>
            
            {/* Main Headline */}
            <motion.h1 initial={{
            opacity: 0,
            scale: 0.9
          }} animate={{
            opacity: 1,
            scale: 1
          }} transition={{
            duration: 0.5,
            delay: 0.1
          }} className="font-display text-[34px] md:text-6xl lg:text-7xl text-white text-outline leading-[1.05] tracking-tight mb-3 uppercase max-w-[95%] animate-mc-breathe" data-id="element-95" data-mp="3pdhp6a8yt6ht">
              ¿TU HIJO AMA MINECRAFT<br data-id="element-96" data-mp="gwd61ywxctb8" />
              PERO NO LAS <span className="text-[#FFC928]" data-id="element-97" data-mp="gvlhh81qvvug">MATEMÁTICAS</span>?
            </motion.h1>
            
            {/* Subheadline */}
            <motion.p initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.5,
            delay: 0.2
          }} className="font-body font-bold text-[#111] text-[16px] leading-[1.3] max-w-[340px] mx-auto mb-4" data-id="element-98" data-mp="2ioj58pgnzy8j">
              Convertí la práctica en misiones y desafíos que realmente tenga ganas de completar.
            </motion.p>
            
            {/* Product Image - HUGE */}
            <motion.div initial={{
            opacity: 0,
            y: 40
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.6,
            delay: 0.3
          }} className="w-[112%] -ml-[6%] md:w-full md:ml-0 mt-2 mb-6" data-id="element-99" data-mp="21nww359bypaq">
              <img src={IMAGES.packCompleto} alt="Pack Completo" className="w-full md:w-[95%] mx-auto block drop-shadow-2xl animate-float" data-id="element-100" data-mp="18zrakgagcw9u" />
            </motion.div>
            
            {/* Dark Panel */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.5,
            delay: 0.4
          }} className="bg-dark-brown text-white font-body font-black text-[14px] md:text-lg h-[50px] flex items-center justify-center px-3 pixel-border hard-shadow w-full max-w-[95%] mb-5 uppercase tracking-wide" data-id="element-101" data-mp="1iy722kde67jv">
              +100 ACTIVIDADES • 5 NIVELES • 5 BONOS GRATIS
            </motion.div>
            
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.5,
            delay: 0.5
          }} className="w-full max-w-[95%]" data-id="element-102" data-mp="ioyy6g7x9jir">
              <CTAButton showTimer={false} showFeatures={true} data-id="element-103" data-mp="8yw7imo9whnl" />
            </motion.div>
          </div>
        </section>

        {/* Pixel Divider */}
        <div className="w-full flex flex-col relative z-10" data-id="element-104" data-mp="3wx63ic3futa">
          <div className="h-6 bg-grass-green border-y-4 border-[#111]" data-id="element-105" data-mp="3w210d5mm1h5t"></div>
          <div className="h-6 bg-medium-brown border-b-4 border-[#111]" data-id="element-106" data-mp="3r2xszej5qyuo"></div>
        </div>

        {/* 2. PROBLEMA */}
        <section className="bg-off-white px-4 py-12 relative overflow-hidden" data-id="element-107" data-mp="3m5xym0vo7kje">
          <motion.h2 initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="font-display text-[30px] md:text-[40px] text-[#111] text-center mb-6 uppercase leading-tight relative z-10" data-id="element-108" data-mp="1pcmd5xv1jdzc">
            ¿TU HIJO AMA LOS JUEGOS...<br data-id="element-109" data-mp="279kguv2nvdun" />
            <span className="text-[#E53E3E]" data-id="element-110" data-mp="278rfk9mh1gjw">PERO LAS MATEMÁTICAS LE PARECEN ABURRIDAS?</span>
          </motion.h2>
          
          <motion.p initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="font-body font-bold text-lg text-center mb-8 text-[#302A26] relative z-10" data-id="element-111" data-mp="22f6j4m0j0umt">
            Sentarlo a practicar no debería convertirse todos los días en una negociación.
          </motion.p>
          
          <div className="flex flex-col gap-4 mb-10 max-w-[90%] mx-auto relative z-10" data-id="element-112" data-mp="1jkriyt2havxe">
            <motion.div initial={{
            opacity: 0,
            x: -30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: 0.2
          }} className="bg-white pixel-border hard-shadow p-4 flex items-center gap-4" data-id="element-113" data-mp="1eleu62s1res6">
              <span className="text-3xl" data-id="element-114" data-mp="3hevjdv3rxidy">😩</span>
              <p className="font-body font-bold text-[#171717] text-lg" data-id="element-115" data-mp="3he3ypfbpt52g">Se aburre rápidamente</p>
            </motion.div>
            <motion.div initial={{
            opacity: 0,
            x: -30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: 0.3
          }} className="bg-white pixel-border hard-shadow p-4 flex items-center gap-4" data-id="element-116" data-mp="3le4hfc5uk2fb">
              <span className="text-3xl" data-id="element-117" data-mp="2yg9h4cwitl8g">🧠</span>
              <p className="font-body font-bold text-[#171717] text-lg" data-id="element-118" data-mp="2yhkloexsix0m">Pierde la concentración</p>
            </motion.div>
            <motion.div initial={{
            opacity: 0,
            x: -30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: 0.4
          }} className="bg-white pixel-border hard-shadow p-4 flex items-center gap-4" data-id="element-119" data-mp="37gftfvghgf61">
              <span className="text-3xl" data-id="element-120" data-mp="mr09nkfolqpw">📚</span>
              <p className="font-body font-bold text-[#171717] text-lg" data-id="element-121" data-mp="msl1v3eiwxkl">Los ejercicios tradicionales no logran engancharlo</p>
            </motion.div>
          </div>
          
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.5
        }} className="bg-yellow-pixel pixel-border hard-shadow p-6 text-center max-w-[95%] mx-auto relative z-10" data-id="element-122" data-mp="1zl6p0a52nss">
            <h3 className="font-body font-black text-xl mb-2 text-[#171717]" data-id="element-123" data-mp="70sdox4gjiye">¿Y si en lugar de luchar contra lo que le gusta... lo usamos a nuestro favor?</h3>
            <p className="font-body font-black text-[24px] md:text-[28px] text-[#171717] uppercase mt-4" data-id="element-124" data-mp="3ahhl0lbv6wp4">
              TRANSFORMÁ LA PRÁCTICA EN UNA MISIÓN.
            </p>
          </motion.div>
        </section>

        {/* Pixel Divider */}
        <div className="w-full flex flex-col relative z-10" data-id="element-125" data-mp="3kduf3kbbncke">
          <div className="h-6 bg-medium-brown border-y-4 border-[#111]" data-id="element-126" data-mp="2wormjhf5fzb4"></div>
          <div className="h-6 bg-grass-green border-b-4 border-[#111]" data-id="element-127" data-mp="2rqq4mztgm618"></div>
        </div>

        {/* 3. PRESENTACIÓN DEL PRODUCTO */}
        <section className="bg-sky-blue px-4 py-12 text-center relative overflow-hidden" data-id="element-128" data-mp="177nqnym6ymab">
          <motion.h2 initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="font-body font-black text-[28px] md:text-[34px] text-[#171717] uppercase mb-4 leading-tight relative z-10" data-id="element-129" data-mp="1c07fjrqbx3uf">
            CONOCÉ +100 ACTIVIDADES DE MATEMÁTICAS
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="font-body font-bold text-[#171717] text-lg bg-white/80 px-4 py-2 pixel-border inline-block mb-10 max-w-[95%] relative z-10" data-id="element-130" data-mp="1uy05ltfutjae">
            Una forma diferente de practicar matemática aprovechando un universo que los chicos ya conocen y disfrutan.
          </motion.p>
          
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.2
        }} className="w-[85%] max-w-[400px] mx-auto mb-10 relative z-10" data-id="element-131" data-mp="9m07wgins2h9">
            <img src={IMAGES.mainBook} alt="Libro Principal" className="w-full block drop-shadow-2xl animate-float" data-id="element-132" data-mp="g31y9nq5m8vu" />
          </motion.div>
          
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-10 text-left max-w-[95%] mx-auto relative z-10" data-id="element-133" data-mp="b12u4bmlb7xu">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: 0.3
          }} className="bg-off-white pixel-border hard-shadow p-4" data-id="element-134" data-mp="13rulmvspn8eu">
              <h4 className="font-body font-black text-[19px] tracking-tight text-[#171717] mb-1 uppercase" data-id="element-135" data-mp="urobnjw80qkf">🎮 APRENDER JUGANDO</h4>
              <p className="font-body font-medium text-[15px] leading-[1.4] text-[#302A26]" data-id="element-136" data-mp="3jkads0xeswne">Actividades presentadas como desafíos.</p>
            </motion.div>
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: 0.4
          }} className="bg-off-white pixel-border hard-shadow p-4" data-id="element-137" data-mp="1uzmp9l12xapg">
              <h4 className="font-body font-black text-[19px] tracking-tight text-[#171717] mb-1 uppercase" data-id="element-138" data-mp="23zjatds69tga">🧠 PRACTICAR</h4>
              <p className="font-body font-medium text-[15px] leading-[1.4] text-[#302A26]" data-id="element-139" data-mp="28s2jbwc05ye8">Conceptos fundamentales de matemática.</p>
            </motion.div>
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: 0.5
          }} className="bg-off-white pixel-border hard-shadow p-4" data-id="element-140" data-mp="2io5wrycb1jgh">
              <h4 className="font-body font-black text-[19px] tracking-tight text-[#171717] mb-1 uppercase" data-id="element-141" data-mp="2roatnejvgzge">🏆 AVANZAR</h4>
              <p className="font-body font-medium text-[15px] leading-[1.4] text-[#302A26]" data-id="element-142" data-mp="sdsyhc6yyrs5">Cada actividad se convierte en un nuevo logro.</p>
            </motion.div>
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: 0.6
          }} className="bg-off-white pixel-border hard-shadow p-4" data-id="element-143" data-mp="20lgonvcupj7q">
              <h4 className="font-body font-black text-[19px] tracking-tight text-[#171717] mb-1 uppercase" data-id="element-144" data-mp="29nzrwgkjtxui">🖨️ IMPRIMIR Y USAR</h4>
              <p className="font-body font-medium text-[15px] leading-[1.4] text-[#302A26]" data-id="element-145" data-mp="24py63nvqnkfc">Elegí las actividades que necesites.</p>
            </motion.div>
          </div>
          
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.7
        }} className="max-w-[90%] mx-auto relative z-10" data-id="element-146" data-mp="2elhzo3mty70x">
            <CTAButton data-id="element-147" data-mp="2ocmen3ci9rvr" />
          </motion.div>
        </section>

        {/* Pixel Divider */}
        <div className="w-full h-4 bg-[#111] relative z-10" data-id="element-148" data-mp="32c3zx8qlen0d"></div>

        {/* 4. MOSTRAR LAS ACTIVIDADES */}
        <section className="bg-[#1A365D] px-4 py-12 text-center border-b-4 border-[#111] relative overflow-hidden" data-id="element-149" data-mp="2xec2jz76i8os">
          {/* Decorative Elements */}
          <GameDecoration type="pig" className="w-[60px] md:w-[80px] top-[20%] right-[5%] md:right-[15%] rotate-12" data-id="element-150" data-mp="3lxnp8wh8bp0d" />
          <GameDecoration type="diamond" className="w-[40px] md:w-[50px] bottom-[20%] left-[5%] md:left-[15%] animate-game-float" data-id="element-151" data-mp="36zbrsnm18c85" />

          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="font-body font-black text-[22px] md:text-2xl text-yellow-pixel mb-2 uppercase animate-mc-breathe relative z-10" data-id="element-152" data-mp="3c1as1omh6t0v">NO ES SOLO UN LIBRO...</motion.h2>
          <motion.h3 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="font-body font-black text-[28px] md:text-[34px] text-white uppercase mb-10 leading-tight relative z-10" data-id="element-153" data-mp="2t8gnlomhajaw">
            SON +100 ACTIVIDADES PARA RESOLVER, PRACTICAR Y SUPERAR
          </motion.h3>
          
          <motion.img initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} src={IMAGES.packCompleto} alt="Hojas de actividades" className="w-[95%] mx-auto block drop-shadow-2xl mb-10 relative z-10" data-id="element-154" data-mp="2ur8bs19u0oud" />
          
          <div className="flex flex-wrap justify-center gap-2 max-w-[95%] mx-auto relative z-10" data-id="element-155" data-mp="2gs8uxfsk9e8r">
            {['NÚMEROS Y CONTEO', 'SUMAS Y RESTAS', 'MULTIPLICACIONES', 'DIVISIONES', 'TABLAS', 'FRACCIONES', 'GEOMETRÍA', 'MEDIDAS', 'DINERO', 'GRÁFICOS', 'PORCENTAJES', 'PROBLEMAS'].map((tag, i) => <motion.span initial={{
            opacity: 0,
            scale: 0.8
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.3,
            delay: 0.3 + i * 0.05
          }} key={i} className="bg-off-white pixel-border hard-shadow px-3 py-1 font-body font-extrabold text-[#171717] text-[14px] md:text-base uppercase" data-id="element-156" data-mp="223m70povbe5x" data-mpi={i}>
                {tag}
              </motion.span>)}
          </div>
        </section>

        {/* CAROUSEL DE MUESTRAS */}
        <AutoScrollCarousel data-id="element-157" data-mp="hlabx4q6ssbb" />

        {/* 5. LOS 5 NIVELES */}
        <section className="bg-off-white px-4 py-12 relative overflow-hidden" data-id="element-158" data-mp="mj3g5s7xjc8y">
          <motion.h2 initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="font-body font-black text-[28px] md:text-[34px] text-[#171717] text-center mb-10 uppercase leading-tight relative z-10" data-id="element-159" data-mp="mgzezi1f0rcd">
            UN MATERIAL QUE LO ACOMPAÑA DE 1.º A 5.º DE PRIMARIA
          </motion.h2>
          
          <div className="flex flex-col gap-4 max-w-[95%] mx-auto relative z-10" data-id="element-160" data-mp="3manny6l6ffo">
            {[{
            level: 1,
            grade: "1.º DE PRIMARIA",
            color: "bg-[#55A83C]",
            topics: "Números y conteo • Sumas y restas • Geometría • Medidas • Dinero",
            iconType: "grass-block"
          }, {
            level: 2,
            grade: "2.º DE PRIMARIA",
            color: "bg-[#ED8936]",
            topics: "Valor posicional • Multiplicación • División • Secuencias • Geometría y medidas",
            iconType: "gold"
          }, {
            level: 3,
            grade: "3.º DE PRIMARIA",
            color: "bg-[#4299E1]",
            topics: "Multiplicaciones • Divisiones • Fracciones • Tablas • Perímetro • Problemas",
            iconType: "diamond"
          }, {
            level: 4,
            grade: "4.º DE PRIMARIA",
            color: "bg-[#9F7AEA]",
            topics: "Operaciones • Múltiplos y divisores • Fracciones y decimales • Área • Gráficos",
            iconType: "emerald"
          }, {
            level: 5,
            grade: "5.º DE PRIMARIA",
            color: "bg-[#F56565]",
            topics: "Porcentajes • Proporciones • Volumen • Geometría • Probabilidad",
            iconType: "trophy"
          }].map((lvl, i) => <motion.div initial={{
            opacity: 0,
            x: -30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: i * 0.15
          }} key={i} className="bg-white pixel-border hard-shadow flex flex-col sm:flex-row relative overflow-hidden z-10" data-id="element-161" data-mp="1fa1mfr0q3t5e" data-mpi={i}>
                <div className="absolute -right-4 -bottom-4 opacity-20 drop-shadow-none pointer-events-none w-24 h-24" data-id="element-162" data-mp="vpjgcv19ajy7">
                  <GameDecoration type={lvl.iconType} className="w-full h-full" data-id="element-163" data-mp="19plxug5njbcx" />
                </div>
                <div className={`${lvl.color} p-4 border-b-4 sm:border-b-0 sm:border-r-4 border-[#111] flex flex-col justify-center items-center sm:w-1/3 relative z-10`} data-id="element-164" data-mp="15le76dfmvlc2">
                  <span className="font-body font-black text-white text-[20px] uppercase flex items-center gap-2" data-id="element-165" data-mp="1emc98q6ihis0">
                    <GameDecoration type={lvl.iconType} className="w-6 h-6 relative" data-id="element-166" data-mp="1tbqo2dsuwses" /> NIVEL {lvl.level}
                  </span>
                  <span className="font-body font-bold text-white text-[16px] text-center mt-1 uppercase leading-tight" data-id="element-167" data-mp="1ofjfseczn4to">{lvl.grade}</span>
                </div>
                <div className="p-4 sm:w-2/3 flex items-center" data-id="element-168" data-mp="1xf6fmvq2k2km">
                  <p className="font-body font-bold text-[#171717] text-[15px] leading-[1.4]" data-id="element-169" data-mp="v0z5zz8yol38">{lvl.topics}</p>
                </div>
              </motion.div>)}
          </div>
        </section>

        {/* Pixel Divider */}
        <div className="w-full flex flex-col relative z-10" data-id="element-170" data-mp="140c7o5qug5de">
          <div className="h-6 bg-grass-green border-y-4 border-[#111]" data-id="element-171" data-mp="18sdq69elusbv"></div>
        </div>

        {/* 6. BENEFICIO EMOCIONAL */}
        <section className="bg-sky-blue px-4 py-12 text-center relative overflow-hidden" data-id="element-172" data-mp="1dq5giyzlq6dy">
          {/* Decorative Elements */}
          <GameDecoration type="torch" className="w-[30px] md:w-[50px] left-0 top-[40%] animate-torch-flicker" data-id="element-173" data-mp="1is4lgdazpbd0" />
          <GameDecoration type="torch" className="w-[30px] md:w-[50px] right-0 top-[40%] animate-torch-flicker" data-id="element-174" data-mp="1nna6zb0hco0k" />

          <div className="bg-off-white pixel-border hard-shadow p-6 md:p-8 max-w-[95%] mx-auto relative z-10" data-id="element-175" data-mp="3pgrac2hkv2pi">
            <motion.h2 initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5
          }} className="font-body font-extrabold text-[21px] leading-[1.15] tracking-[-0.3px] text-[#171717] mb-4 uppercase" data-id="element-176" data-mp="3thjmb3hu3lph">
              MENOS "NO QUIERO<br data-id="element-177" data-mp="3c7z7fj9zx5rf" />HACER MATEMÁTICA"...
            </motion.h2>
            <motion.h3 initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: 0.1
          }} className="font-body font-black text-[27px] leading-[1.05] tracking-[-0.5px] text-[#171717] mb-6 uppercase" data-id="element-178" data-mp="3c6eajn07laqe">
              Y MÁS...<br data-id="element-179" data-mp="3vwq2v9wmcq8c" />"¿CUÁL ES LA<br data-id="element-180" data-mp="3vwhspprvrz0u" /><span className="text-[#F6B900]" data-id="element-181" data-mp="3vw89cl1ccq44">PRÓXIMA MISIÓN?</span>" 🎮
            </motion.h3>
            
            <motion.p initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: 0.2
          }} className="font-body font-bold text-[#302A26] text-[16px] md:text-[18px] leading-[1.45] mb-8" data-id="element-182" data-mp="3qyg7ozaw9pmq">
              No buscamos reemplazar la enseñanza escolar. Buscamos darle una forma diferente de practicar lo que necesita aprender.
            </motion.p>
            
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 text-left" data-id="element-183" data-mp="c2la2i6m3etm">
              {['Más interés', 'Más práctica', 'Más autonomía', 'Menos resistencia'].map((item, i) => <motion.div initial={{
              opacity: 0,
              scale: 0.9
            }} whileInView={{
              opacity: 1,
              scale: 1
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.4,
              delay: 0.3 + i * 0.1
            }} key={i} className="group flex items-center gap-3 bg-white pixel-border p-3 transition-all duration-200 hover:-translate-y-1 hover:shadow-[4px_4px_0px_0px_#111] cursor-default" data-id="element-184" data-mp="2ayphv8dw3e7" data-mpi={i}>
                  <div className="bg-grass-green w-8 h-8 flex items-center justify-center flex-shrink-0 border-2 border-[#111] group-hover:bg-yellow-pixel transition-colors duration-200" data-id="element-185" data-mp="lwv1nxnqc93a">
                    <span className="text-white font-bold text-xl leading-none animate-level-up" style={{
                  animationDelay: `${i * 0.2}s`
                }} data-id="element-186" data-mp="36qi1z2yhgyj1">✓</span>
                  </div>
                  <span className="font-body font-bold text-[16px] text-[#171717] group-hover:text-grass-green transition-colors duration-200" data-id="element-187" data-mp="2u72upbt46h3g">{item}</span>
                </motion.div>)}
            </div>
          </div>
        </section>

        {/* Pixel Divider */}
        <div className="w-full h-4 bg-[#111] relative z-10" data-id="element-188" data-mp="2fh5d5epowpn8"></div>

        {/* 7. LOS 5 BONOS */}
        <section className="bg-[#9F7AEA] px-4 py-12 text-center border-b-4 border-[#111] relative overflow-hidden" data-id="element-189" data-mp="2ailq1azd17ta">
          {/* Decorative Elements */}
          <GameDecoration type="chest" className="w-[60px] md:w-[80px] top-[10%] right-[10%]" data-id="element-190" data-mp="2p8sxywrqr8fq" />
          <GameDecoration type="diamond" className="w-[30px] md:w-[40px] top-[30%] left-[5%] animate-game-float" data-id="element-191" data-mp="2kex68c22mht0" />
          <GameDecoration type="diamond" className="w-[25px] md:w-[35px] bottom-[40%] right-[5%] animate-game-float" style={{
          animationDelay: '1s'
        }} data-id="element-192" data-mp="1woufbz9w7hvz" />
          <GameDecoration type="diamond" className="w-[35px] md:w-[45px] bottom-[10%] left-[10%] animate-game-float" style={{
          animationDelay: '2s'
        }} data-id="element-193" data-mp="3ruvg0q5balfo" />

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="font-body font-black text-[18px] text-yellow-pixel mb-2 uppercase animate-mc-breathe relative z-10" data-id="element-194" data-mp="lobkq5oq3si">PERO ESO NO ES TODO...</motion.p>
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="font-display text-4xl md:text-5xl text-white text-outline uppercase mb-12 leading-tight animate-mc-breathe relative z-10" data-id="element-195" data-mp="38xkib9zbw02c">
            🎁 TE LLEVÁS 5 BONOS GRATIS
          </motion.h2>
          
          <div className="flex flex-col gap-12 max-w-[90%] mx-auto relative z-10" data-id="element-196" data-mp="x7rlwguf8gw9">
            {/* Bono 1 */}
            <motion.div initial={{
            opacity: 0,
            y: 40
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: 0.2
          }} className="bg-white pixel-border hard-shadow p-6 relative" data-id="element-197" data-mp="126kym71vw3vd">
              <div className="absolute bottom-4 right-4 text-3xl drop-shadow-[2px_2px_0px_rgba(17,17,17,1)] opacity-70" data-id="element-198" data-mp="12idk0cbuvt3m">🏆</div>
              <div className="absolute -top-4 -right-2 bg-yellow-pixel text-[#111] font-display text-xl pixel-border px-3 py-1 transform rotate-3 uppercase animate-gift-pop" data-id="element-199" data-mp="ygiknddhjpsh">GRATIS</div>
              <img src={IMAGES.bonus1} alt="Tarjetas de Recompensa" className="w-[80%] max-w-[250px] h-[250px] object-contain mx-auto mb-6 drop-shadow-xl animate-gift-pop" style={{
              animationDelay: '0.5s'
            }} data-id="element-200" data-mp="oiumedgo805k" />
              <h3 className="font-body font-black text-[18px] text-[#9F7AEA] mb-1 uppercase" data-id="element-201" data-mp="fjhcjjomx9kb">BONO #1</h3>
              <h4 className="font-body font-black text-[22px] md:text-[26px] text-[#171717] mb-2 uppercase leading-tight" data-id="element-202" data-mp="2dwr4r8bbbsff">TARJETAS DE RECOMPENSA</h4>
              <p className="font-body font-bold text-[#E53E3E] mb-3 uppercase text-[15px]" data-id="element-203" data-mp="2t572u1bxch45">¡DESBLOQUEÁ SUS LOGROS!</p>
              <p className="font-body font-medium text-[#302A26] text-[15px] leading-[1.45] md:text-base" data-id="element-204" data-mp="2x7btqsazmzn3">Reconocé cada actividad completada y ayudalo a mantener sus ganas de continuar.</p>
            </motion.div>

            {/* Bono 2 */}
            <motion.div initial={{
            opacity: 0,
            y: 40
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: 0.3
          }} className="bg-white pixel-border hard-shadow p-6 relative" data-id="element-205" data-mp="2ocxg0u63vx63">
              <div className="absolute bottom-4 right-4 text-3xl drop-shadow-[2px_2px_0px_rgba(17,17,17,1)] opacity-70" data-id="element-206" data-mp="2ee7yj2i4geqd">🧭</div>
              <div className="absolute -top-4 -left-2 bg-yellow-pixel text-[#111] font-display text-xl pixel-border px-3 py-1 transform -rotate-3 uppercase animate-gift-pop" style={{
              animationDelay: '0.2s'
            }} data-id="element-207" data-mp="25fcqdkvioukf">GRATIS</div>
              <img src={IMAGES.bonus2} alt="Mapa de Progreso" className="w-[80%] max-w-[250px] h-[250px] object-contain mx-auto mb-6 drop-shadow-xl animate-gift-pop" style={{
              animationDelay: '0.7s'
            }} data-id="element-208" data-mp="3oj64kal3p63" />
              <h3 className="font-body font-black text-[18px] text-[#9F7AEA] mb-1 uppercase" data-id="element-209" data-mp="8twfrpwcku0c">BONO #2</h3>
              <h4 className="font-body font-black text-[22px] md:text-[26px] text-[#171717] mb-2 uppercase leading-tight" data-id="element-210" data-mp="mljnqmznjqyy">MAPA DE PROGRESO</h4>
              <p className="font-body font-bold text-[#E53E3E] mb-3 uppercase text-[15px]" data-id="element-211" data-mp="hrox0zlmqbqd">¡QUE VEA TODO LO QUE AVANZÓ!</p>
              <p className="font-body font-medium text-[#302A26] text-[15px] leading-[1.45] md:text-base" data-id="element-212" data-mp="rjl3oz1s7a67">Convertí cada actividad completada en un paso visible hacia su próxima meta.</p>
            </motion.div>

            {/* Bono 3 */}
            <motion.div initial={{
            opacity: 0,
            y: 40
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: 0.4
          }} className="bg-white pixel-border hard-shadow p-6 relative" data-id="element-213" data-mp="11ittrgtj04na">
              <div className="absolute -top-4 -right-2 bg-yellow-pixel text-[#111] font-display text-xl pixel-border px-3 py-1 transform rotate-3 uppercase animate-gift-pop" style={{
              animationDelay: '0.4s'
            }} data-id="element-214" data-mp="33aykiozagvwf">GRATIS</div>
              <img src={IMAGES.bonus3} alt="Guía para Padres" className="w-[80%] max-w-[250px] h-[250px] object-contain mx-auto mb-6 drop-shadow-xl animate-gift-pop" style={{
              animationDelay: '0.9s'
            }} data-id="element-215" data-mp="1dlg5sqovcjap" />
              <h3 className="font-body font-black text-[18px] text-[#9F7AEA] mb-1 uppercase" data-id="element-216" data-mp="1njnl753ietal">BONO #3</h3>
              <h4 className="font-body font-black text-[22px] md:text-[26px] text-[#171717] mb-2 uppercase leading-tight" data-id="element-217" data-mp="21eppjnspkala">GUÍA PARA PADRES Y DOCENTES</h4>
              <p className="font-body font-medium text-[#302A26] text-[15px] leading-[1.45] md:text-base mt-4" data-id="element-218" data-mp="2b5kamou7x455">Ideas prácticas para acompañar, motivar y aprovechar mejor cada actividad, tanto en casa como en el aula.</p>
            </motion.div>

            {/* Bono 4 */}
            <motion.div initial={{
            opacity: 0,
            y: 40
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: 0.5
          }} className="bg-white pixel-border hard-shadow p-6 relative" data-id="element-219" data-mp="2f8z0e77ykyvs">
              <div className="absolute bottom-4 right-4 text-3xl drop-shadow-[2px_2px_0px_rgba(17,17,17,1)] opacity-70" data-id="element-220" data-mp="33sagumrf1iyx">🧩</div>
              <div className="absolute -top-4 -left-2 bg-yellow-pixel text-[#111] font-display text-xl pixel-border px-3 py-1 transform -rotate-3 uppercase animate-gift-pop" style={{
              animationDelay: '0.6s'
            }} data-id="element-221" data-mp="2ptax9tirfu9m">GRATIS</div>
              <img src={IMAGES.bonus4} alt="Problemas Matemáticos" className="w-[80%] max-w-[250px] h-[250px] object-contain mx-auto mb-6 drop-shadow-xl animate-gift-pop" style={{
              animationDelay: '1.1s'
            }} data-id="element-222" data-mp="2g1y1wrxr6lyu" />
              <h3 className="font-body font-black text-[18px] text-[#9F7AEA] mb-1 uppercase" data-id="element-223" data-mp="2b4o6mvnong33">BONO #4</h3>
              <h4 className="font-body font-black text-[22px] md:text-[26px] text-[#171717] mb-2 uppercase leading-tight" data-id="element-224" data-mp="1x559sz0bnr63">PROBLEMAS MATEMÁTICOS</h4>
              <p className="font-body font-bold text-[#E53E3E] mb-3 uppercase text-[15px]" data-id="element-225" data-mp="222oqe5khsg17">¡DESAFÍOS PARA PENSAR!</p>
              <p className="font-body font-medium text-[#302A26] text-[15px] leading-[1.45] md:text-base" data-id="element-226" data-mp="7p2pdlsal2nj">Situaciones para pensar, resolver y superar, llevando la lógica matemática un paso más allá.</p>
            </motion.div>

            {/* Bono 5 */}
            <motion.div initial={{
            opacity: 0,
            y: 40
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: 0.6
          }} className="bg-white pixel-border hard-shadow p-6 relative" data-id="element-227" data-mp="3q2k1ess1zpnt">
              <div className="absolute bottom-4 right-4 text-3xl drop-shadow-[2px_2px_0px_rgba(17,17,17,1)] opacity-70" data-id="element-228" data-mp="lou81ztr777v">✖️</div>
              <div className="absolute -top-4 -right-2 bg-yellow-pixel text-[#111] font-display text-xl pixel-border px-3 py-1 transform rotate-3 uppercase animate-gift-pop" style={{
              animationDelay: '0.8s'
            }} data-id="element-229" data-mp="ho1zz9wmb8d6">GRATIS</div>
              <img src={IMAGES.bonus5} alt="Tabla de Multiplicar" className="w-[80%] max-w-[250px] h-[250px] object-contain mx-auto mb-6 drop-shadow-xl animate-gift-pop" style={{
              animationDelay: '1.3s'
            }} data-id="element-230" data-mp="2xd3bc1rwokur" />
              <h3 className="font-body font-black text-[18px] text-[#9F7AEA] mb-1 uppercase" data-id="element-231" data-mp="1hu5hr1oo2fzc">BONO #5</h3>
              <h4 className="font-body font-black text-[22px] md:text-[26px] text-[#171717] mb-2 uppercase leading-tight" data-id="element-232" data-mp="1lvzbeq0g2jq0">TABLA DE MULTIPLICAR</h4>
              <p className="font-body font-bold text-[#E53E3E] mb-3 uppercase text-[15px]" data-id="element-233" data-mp="1qo0lq6e1y0de">¡APRENDÉ Y DOMINÁ!</p>
              <p className="font-body font-medium text-[#302A26] text-[15px] leading-[1.45] md:text-base" data-id="element-234" data-mp="1vlalaev5nsey">Practicá las tablas paso a paso hasta memorizarlas y dominarlas por completo.</p>
            </motion.div>
          </div>
          
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.7
        }} className="mt-12 bg-yellow-pixel pixel-border hard-shadow p-4 inline-block max-w-[95%] relative z-10" data-id="element-235" data-mp="29l1r3sbiq2hv">
            <p className="font-body font-black text-[18px] md:text-[22px] text-[#171717] uppercase leading-tight" data-id="element-236" data-mp="3g28a018nbu68">LOS 5 BONOS ESTÁN INCLUIDOS SIN COSTO EXTRA</p>
          </motion.div>
        </section>

        {/* 8. TODO LO QUE RECIBÍS */}
        <section className="bg-off-white px-4 py-12 relative overflow-hidden" data-id="element-237" data-mp="3pzd0uedfsdtd">
          <motion.h2 initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="font-body font-black text-[28px] md:text-[34px] text-[#171717] text-center mb-10 uppercase leading-tight relative z-10" data-id="element-238" data-mp="3l1bixwrqykjh">
            MIRÁ TODO LO QUE TE LLEVÁS HOY
          </motion.h2>
          
          <motion.div initial={{
          opacity: 0,
          y: 40
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="bg-white pixel-border hard-shadow p-6 max-w-[95%] mx-auto relative z-10" data-id="element-239" data-mp="32bdavgny8rfu">
            <img src={IMAGES.packCompleto} alt="Todo lo que recibís" className="w-[95%] mx-auto mb-8 drop-shadow-xl" data-id="element-240" data-mp="29kbrt4h4ybr1" />
            
            <ul className="space-y-4 font-body font-bold text-[#171717] text-[16px] md:text-[18px] mb-10" data-id="element-241" data-mp="tuu2v5thgbn6">
              <li className="flex items-center gap-3" data-id="element-242" data-mp="g48qlzyjazy9"><span className="text-2xl" data-id="element-243" data-mp="g5a5kfio86l9">📘</span> +100 Actividades de Matemáticas</li>
              <li className="flex items-center gap-3" data-id="element-244" data-mp="k63r528n59az"><span className="text-2xl" data-id="element-245" data-mp="k2y19ks6u3e7">📚</span> Contenido de 1.º a 5.º de primaria</li>
              <li className="flex items-center gap-3" data-id="element-246" data-mp="17ssbrvp1bfva"><span className="text-2xl" data-id="element-247" data-mp="1cuhp5hzqc5mj">🏆</span> Tarjetas de Recompensa (GRATIS)</li>
              <li className="flex items-center gap-3" data-id="element-248" data-mp="yugpg5v7b48n"><span className="text-2xl" data-id="element-249" data-mp="ytf14zp6cl8z">🗺️</span> Mapa de Progreso (GRATIS)</li>
              <li className="flex items-center gap-3" data-id="element-250" data-mp="13si7cngw4xij"><span className="text-2xl" data-id="element-251" data-mp="13rgm5q65uun3">👨‍👩‍👧‍👦</span> Guía para Padres y Docentes (GRATIS)</li>
              <li className="flex items-center gap-3" data-id="element-252" data-mp="3jj4fzcpvo71o"><span className="text-2xl" data-id="element-253" data-mp="3oj90rextjnxp">🧩</span> Problemas Matemáticos (GRATIS)</li>
              <li className="flex items-center gap-3" data-id="element-254" data-mp="1u3aikk7oq481"><span className="text-2xl" data-id="element-255" data-mp="1u28xdmwyg1cl">✖️</span> Tabla de Multiplicar (GRATIS)</li>
              <li className="flex items-center gap-3" data-id="element-256" data-mp="1p3xlz7r0his9"><span className="text-2xl" data-id="element-257" data-mp="1p4zaadx1g1rx">📄</span> Material digital</li>
              <li className="flex items-center gap-3" data-id="element-258" data-mp="1kcfl0jozni7a"><span className="text-2xl" data-id="element-259" data-mp="1kbe96d05eroi">🖨️</span> Listo para imprimir</li>
              <li className="flex items-center gap-3" data-id="element-260" data-mp="1gbdviukvikii"><span className="text-2xl" data-id="element-261" data-mp="1bcsu4rtvxush">⚡</span> Acceso inmediato</li>
            </ul>
            
            <div className="bg-dark-brown pixel-border p-4 md:p-6 text-center text-white relative mt-6" data-id="element-262" data-mp="16dpnx4265iix">
              <div className="absolute -top-4 left-1/2 transform -translate-x-1/2 bg-yellow-pixel text-[#111] font-body font-black text-[12px] md:text-[14px] pixel-border px-3 py-1 uppercase whitespace-nowrap" data-id="element-263" data-mp="11emqa4oiqekz">
                TODO EL MATERIAL + LOS 5 BONOS
              </div>
              
              <div className="flex flex-col md:flex-row items-center justify-center gap-2 md:gap-6 mt-3 mb-4" data-id="element-264" data-mp="2rr2i3ku7this">
                <div className="flex flex-col items-center" data-id="element-265" data-mp="djjdnoou9hnq">
                  <p className="font-body font-bold text-gray-400 text-[16px] line-through mb-0" data-id="element-266" data-mp="dj1digz22jaj">Valor: $35.980</p>
                  <div className="bg-[#E53E3E] text-white font-body font-black px-2 py-0.5 pixel-border text-[14px] uppercase mt-1" data-id="element-267" data-mp="ig1ieok65g02">AHORRÁS 50%</div>
                </div>
                <p className="font-display text-4xl md:text-5xl text-yellow-pixel text-outline-sm uppercase leading-none" data-id="element-268" data-mp="ra6fvqtt5pok">
                  <span className="text-[20px] block md:inline md:mr-2 text-white text-outline-none" data-id="element-269" data-mp="3qs618y242dk1">HOY</span>
                  $17.990 ARS
                </p>
              </div>
              
              <CTAButton data-id="element-270" data-mp="3n83b48t71vx" />
            </div>
          </motion.div>
        </section>

        {/* Pixel Divider */}
        <div className="w-full flex flex-col relative z-10" data-id="element-271" data-mp="1f0ahxtrclhdg">
          <div className="h-6 bg-medium-brown border-y-4 border-[#111]" data-id="element-272" data-mp="1ezqyg8m1ukxb"></div>
          <div className="h-6 bg-grass-green border-b-4 border-[#111]" data-id="element-273" data-mp="1jyc10eorxgox"></div>
        </div>

        {/* 9. CÓMO FUNCIONA */}
        <section className="bg-sky-blue px-4 py-12 text-center relative overflow-hidden" data-id="element-274" data-mp="vnba90uuwofk">
          <motion.h2 initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="font-body font-black text-[28px] md:text-[34px] text-[#171717] uppercase mb-10 leading-tight relative z-10" data-id="element-275" data-mp="qp05v5nbz64q">
            EMPEZAR ES MUY FÁCIL
          </motion.h2>
          
          <div className="flex flex-col gap-6 max-w-[95%] mx-auto relative z-10" data-id="element-276" data-mp="19egeyhd306wr">
            {[{
            step: "1",
            title: "COMPRÁS",
            desc: "Realizás tu compra de forma segura."
          }, {
            step: "2",
            title: "RECIBÍS EL MATERIAL",
            desc: "Accedés al contenido digital al instante."
          }, {
            step: "3",
            title: "IMPRIMÍS Y EMPIEZAN LAS MISIONES",
            desc: "Elegí las actividades y comenzá a utilizarlas."
          }].map((item, i) => <motion.div initial={{
            opacity: 0,
            x: -30
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: i * 0.2
          }} key={i} className="bg-off-white pixel-border hard-shadow p-4 flex items-center gap-4 text-left" data-id="element-277" data-mp="3l5k6klxdbpic" data-mpi={i}>
                <div className="bg-yellow-pixel pixel-border w-14 h-14 flex-shrink-0 flex items-center justify-center font-body font-black text-[24px] text-[#171717]" data-id="element-278" data-mp="319r0149ttoa3">
                  {item.step}
                </div>
                <div data-id="element-279" data-mp="2re5y164rco0c">
                  <h3 className="font-body font-black text-[18px] md:text-[20px] text-[#171717] uppercase mb-1" data-id="element-280" data-mp="2wbfngls5czo6">{item.title}</h3>
                  <p className="font-body font-medium text-[15px] leading-[1.45] text-[#302A26]" data-id="element-281" data-mp="2icg9q966a56s">{item.desc}</p>
                </div>
              </motion.div>)}
          </div>
        </section>

        {/* Pixel Divider */}
        <div className="w-full flex flex-col relative z-10" data-id="element-282" data-mp="ghxhoaf4z5hn">
          <div className="h-6 bg-grass-green border-y-4 border-[#111]" data-id="element-283" data-mp="lhjw2n6pars1"></div>
          <div className="h-6 bg-medium-brown border-b-4 border-[#111]" data-id="element-284" data-mp="1nbagronkvpww"></div>
        </div>

        {/* 10. PARA QUIÉN ES */}
        <section className="bg-medium-brown px-4 py-12 relative overflow-hidden" data-id="element-285" data-mp="1sadkn5rtnq3a">
          <motion.h2 initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="font-body font-black text-[28px] md:text-[34px] text-white text-center mb-10 uppercase relative z-10" data-id="element-286" data-mp="1x7nkzggr1m5w">
            IDEAL PARA...
          </motion.h2>
          
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 max-w-[95%] mx-auto relative z-10" data-id="element-287" data-mp="2b26gd7y9zpep">
            {[{
            icon: "👦",
            text: "Chicos de 1.º a 5.º de primaria"
          }, {
            icon: "🏠",
            text: "Familias que buscan reforzar matemática en casa"
          }, {
            icon: "👩‍🏫",
            text: "Docentes que buscan actividades diferentes"
          }, {
            icon: "📚",
            text: "Refuerzo escolar"
          }, {
            icon: "☀️",
            text: "Vacaciones"
          }, {
            icon: "🧠",
            text: "Práctica semanal"
          }].map((item, i) => <motion.div initial={{
            opacity: 0,
            scale: 0.9
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: i * 0.1
          }} key={i} className="bg-off-white pixel-border hard-shadow p-4 flex items-center gap-4" data-id="element-288" data-mp="2z2qldg7ruoo4" data-mpi={i}>
                <span className="text-3xl" data-id="element-289" data-mp="3mtnkttidrtih">{item.icon}</span>
                <span className="font-body font-bold text-[#171717] text-base" data-id="element-290" data-mp="3irso72bea4b1">{item.text}</span>
              </motion.div>)}
          </div>
        </section>

        {/* Pixel Divider */}
        <div className="w-full h-4 bg-[#111] relative z-10" data-id="element-291" data-mp="38tl9yr8hq0cq"></div>

        {/* 11. FAQ */}
        <section className="bg-off-white px-4 py-12 relative overflow-hidden" data-id="element-292" data-mp="38vz0qnw50qeh">
          <motion.h2 initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="font-body font-black text-[28px] md:text-[34px] text-[#171717] text-center mb-10 uppercase relative z-10" data-id="element-293" data-mp="22eu4ea8f9rcd">
            PREGUNTAS FRECUENTES
          </motion.h2>
          
          <div className="flex flex-col gap-4 max-w-[95%] mx-auto relative z-10" data-id="element-294" data-mp="1pvq1s6so4qz3">
            {faqs.map((faq, i) => <motion.details initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: i * 0.1
          }} key={i} className="group bg-white pixel-border hard-shadow" data-id="element-295" data-mp="1usotkiov0lu4" data-mpi={i}>
                <summary className="font-body font-black text-[16px] md:text-[18px] p-4 cursor-pointer flex justify-between items-center list-none uppercase text-[#171717]" data-id="element-296" data-mp="174p21gjq4reh">
                  <span className="pr-4" data-id="element-297" data-mp="1b3o50vlwae3a">{faq.q}</span>
                  <span className="text-2xl group-open:rotate-180 transition-transform" data-id="element-298" data-mp="x7kg9htsixy7">▼</span>
                </summary>
                <div className="p-4 pt-0 font-body font-medium text-[15px] leading-[1.45] text-[#302A26] border-t-4 border-[#111]" data-id="element-299" data-mp="124klxrmq9yos">
                  {faq.a}
                </div>
              </motion.details>)}
          </div>
        </section>

        {/* Pixel Divider */}
        <div className="w-full flex flex-col relative z-10" data-id="element-300" data-mp="sjbazrtv4a5j">
          <div className="h-6 bg-medium-brown border-y-4 border-[#111]" data-id="element-301" data-mp="ni43zuzjnezx"></div>
          <div className="h-6 bg-grass-green border-b-4 border-[#111]" data-id="element-302" data-mp="11ievn08ogxm5"></div>
        </div>

        {/* 12. CTA FINAL */}
        <section className="bg-sky-blue px-4 py-16 text-center relative overflow-hidden" data-id="element-303" data-mp="wjv8wxm9fhsq">
          {/* Decorative Elements */}
          <GameDecoration type="torch" className="w-[30px] md:w-[50px] left-[5%] top-[30%] animate-torch-flicker" data-id="element-304" data-mp="1b6wrr460igjg" />
          <GameDecoration type="torch" className="w-[30px] md:w-[50px] right-[5%] top-[30%] animate-torch-flicker" data-id="element-305" data-mp="169wvtm2vmu62" />
          <GameDecoration type="diamond" className="w-[40px] md:w-[60px] right-[20%] bottom-[30%] animate-game-float" data-id="element-306" data-mp="1k6th78087jfk" />
          <GameDecoration type="grass-block" className="w-[40px] md:w-[50px] left-[10%] bottom-[-10px]" data-id="element-307" data-mp="39qbb98j5uos5" />
          <GameDecoration type="grass-block" className="w-[30px] md:w-[40px] left-[25%] bottom-[-5px]" data-id="element-308" data-mp="3eouzxgp52eo7" />
          <GameDecoration type="grass-block" className="w-[50px] md:w-[60px] right-[15%] bottom-[-15px]" data-id="element-309" data-mp="3jfbcyzp1rya1" />

          <motion.h2 initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5
        }} className="font-body font-black text-[28px] md:text-[34px] text-[#171717] uppercase mb-6 leading-tight relative z-10" data-id="element-310" data-mp="3of7fsvm0djo0">
            HOY PUEDE SER EL DÍA EN QUE PRACTICAR MATEMÁTICA DEJE DE SER UNA PELEA.
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.1
        }} className="font-body font-bold text-[#171717] text-[16px] md:text-[18px] bg-white/80 px-4 py-2 pixel-border inline-block mb-10 max-w-[95%] relative z-10" data-id="element-311" data-mp="34rglfmmrzzyj">
            Transformá sus ejercicios en desafíos que realmente tenga ganas de completar.
          </motion.p>
          
          <motion.div initial={{
          opacity: 0,
          y: 40
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="bg-off-white pixel-border hard-shadow p-6 max-w-[95%] mx-auto relative z-10" data-id="element-312" data-mp="20j9nisx44zkr">
            <img src={IMAGES.packCompleto} alt="Pack Completo" className="w-[95%] mx-auto mb-8 drop-shadow-xl" data-id="element-313" data-mp="1ltu0no0pdeac" />
            
            <div className="flex flex-col gap-3 mb-8" data-id="element-314" data-mp="1gvaafbf2tgc6">
              <span className="bg-grass-green text-white font-body font-black pixel-border px-4 py-2 text-[18px] uppercase" data-id="element-315" data-mp="1csm172mga7eo">+100 ACTIVIDADES</span>
              <span className="bg-yellow-pixel text-[#111] font-body font-black pixel-border px-4 py-2 text-[18px] uppercase" data-id="element-316" data-mp="17uub8e5d8vd4">+ 5 BONOS GRATIS</span>
            </div>
            
            <div className="bg-dark-brown pixel-border p-4 md:p-6 text-center text-white mb-6" data-id="element-317" data-mp="327adz4yydrd8">
              <div className="flex flex-col md:flex-row items-center justify-center gap-2 md:gap-6 mb-4" data-id="element-318" data-mp="3l9ufcunf458u">
                <div className="flex flex-col items-center" data-id="element-319" data-mp="3q35gqg9gnttd">
                  <p className="font-body font-bold text-gray-400 text-[16px] line-through mb-0" data-id="element-320" data-mp="3cbigy6gb835u">Antes: $35.980</p>
                  <div className="bg-[#E53E3E] text-white font-body font-black px-2 py-0.5 pixel-border text-[14px] uppercase mt-1" data-id="element-321" data-mp="3habs3s84ji2u">AHORRÁS 50%</div>
                </div>
                <p className="font-display text-4xl md:text-5xl text-yellow-pixel text-outline-sm uppercase leading-none" data-id="element-322" data-mp="cvu3xqo1x5xo">
                  <span className="text-[20px] block md:inline md:mr-2 text-white text-outline-none" data-id="element-323" data-mp="3v05l8mqnwoid">HOY</span>
                  $17.990 ARS
                </p>
              </div>
              <CTAButton data-id="element-324" data-mp="2jlij2rk87qch" />
            </div>
          </motion.div>
        </section>
        
        {/* Footer */}
        <footer className="bg-[#111] text-gray-400 py-8 px-4 text-center font-body font-bold text-xs border-t-4 border-[#111] relative z-10" data-id="element-325" data-mp="2olo4hpzwkgm4">
          <p className="mb-2" data-id="element-326" data-mp="2h36t1e8gurqi">© {new Date().getFullYear()} Lectura Mundo Bloques. Todos los derechos reservados.</p>
          <p data-id="element-327" data-mp="2q1s6iuz2zgkf">Este producto no está asociado, afiliado, respaldado, certificado ni patrocinado por Mojang AB o Microsoft. Minecraft es una marca registrada de Mojang Synergies AB.</p>
        </footer>

      </div>
    </div>;
}